<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title style="align-items: start">
          <v-row no-gutters align="start">
            <ChipsLabel
              v-if="isShowEstimate"
              :value="devProgress"
              :color="devProgress ? devProgress.color : ''"
            />
            <ChipsLabel
              v-if="isShowEstimate"
              :value="totalTimeSpentSeconds"
              :color="totalTimeSpentSeconds ? totalTimeSpentSeconds.color : ''"
              class="ml-2"
            />
            <ChipsLabel
              v-if="isShowEstimate"
              :value="factWithGrades"
              :color="factWithGrades ? factWithGrades.color : ''"
              class="ml-2"
            />
            <v-spacer />
            <IconBtnTooltip
              icon="mdi-information-variant"
              :tooltip="infoText"
            />
            <v-menu
              v-model="trackerEditMode"
              :close-on-content-click="false"
              left
              offset-x
              :disabled="!issueTrackerRef"
            >
              <template #activator="{ on: onMenu }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on: onTooltip }">
                    <v-btn class="mx-2" icon v-on="{ ...onMenu, ...onTooltip }">
                      <v-icon :color="issueTrackerRef ? 'blue darken-1' : ''">
                        mdi-jira
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Код задачі Jira</span>
                </v-tooltip>
              </template>
              <v-card class="pa-5">
                <div class="d-flex align-center">
                  <CustomTextField
                    v-model="issueTrackerRef"
                    label="Jira"
                    append-icon="search"
                    :loading="loading"
                    :disabled="!issueTrackerRef"
                    readonly
                    @click:append="openIssue(issueTrackerRef)"
                  />
                </div>
              </v-card>
            </v-menu>
            <MenuDownload
              :location="`specifications/${id}/rpc/export-to-excel?culture=`"
              filename="Спецификации"
              extension="xlsx"
              tooltip="Завантажити у форматі Excel"
              :bottom="true"
            />
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-col class="pa-0">
              <span class="title font-weight-bold pa-0 mb-3">
                {{ header }}
              </span>
            </v-col>
            <v-data-table
              v-if="isShowEstimate"
              :headers="totalHeaders"
              hide-default-footer
              hide-default-header
              :items="totalEstimate"
              style="top: 45px"
              class="fixed-total"
              no-data-text="Даних немає"
            >
              <template v-slot:item="{ item }">
                <tr style="background: #ECEFF1">
                  <td
                    v-for="(column, index) in totalHeaders"
                    :key="index"
                    class="px-1"
                    :style="column.style"
                  >
                    <v-chip
                      v-if="column.type === 'chips'"
                      label
                      small
                      outlined
                      :color="getColorTotalEstimate(item, column.value)"
                      style="height: 50px; width: 50px"
                      class="px-1"
                    >
                      <span
                        >{{ `${column.text}:` }}<br />
                        {{ `${item[column.value]}` }}</span
                      >
                    </v-chip>
                    <span v-else class="font-weight-bold mr-2">{{
                      item[column.value]
                    }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <div v-for="(section, i) in items" :key="i" class="mt-5">
              <span class="subtitle-1 font-weight-bold">
                {{ section[0].section }}
              </span>
              <v-data-table
                :headers="sectionHeaders"
                :items="section"
                :items-per-page="-1"
                fixed-header
                :height="section.length > 5 ? '300' : 'auto'"
                hide-default-footer
                no-data-text="Даних немає"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="(column, index) in sectionHeaders"
                      :key="index"
                      :style="column.style"
                    >
                      <span
                        v-if="
                          column.type === 'jira-editor' && !item.isTestSection
                        "
                      >
                        <JiraTrackerMenu
                          v-if="item.issueJiraDev || item.issueJiraAnalyst"
                          :item="item"
                        />
                        <v-icon v-else small>
                          mdi-jira
                        </v-icon>
                      </span>
                      <span v-else>{{ item[column.value] }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ChipsLabel from "../../../components/ChipsLabel.vue";
import IconBtnTooltip from "../../../components/IconBtnTooltip.vue";
import JiraTrackerMenu from "./JiraTrackerMenu.vue";
import MenuDownload from "../../../components/MenuDownload.vue";

import * as specificationsApi from "../../../backend/specificationsApi.js";
import itemsHeaders from "./itemsHeaders.js";
import _ from "lodash";

export default {
  components: {
    ChipsLabel,
    IconBtnTooltip,
    JiraTrackerMenu,
    MenuDownload,
  },

  props: ["id"],

  data: () => ({
    title: "",
    createdAt: "",
    issueTrackerRef: "",
    items: [],
    sections: [],
    loading: false,
    author: "",
    devProgress: null,
    factWithGrades: null,
    totalTimeSpentSeconds: null,
    totalEstimate: [],
    isShowEstimate: false,
    testIndex: 0,
    trackerEditMode: false,
  }),

  computed: {
    header() {
      return this.title ? this.title : "Специфікація";
    },
    totalHeaders() {
      return itemsHeaders.totalHeaders;
    },
    sectionHeaders() {
      return itemsHeaders.sectionHeaders;
    },
    infoText() {
      return `Автор: ${
        this.author
      };  Дата створення: ${this.$options.filters.date(this.createdAt)}`;
    },
  },
  created() {
    this.getSpecification();
    if (!this.testIndex) {
      this.testIndex = 0.25;
    }
  },
  methods: {
    async getSpecification() {
      if (!this.id) {
        return;
      }
      this.loading = true;
      const data = await specificationsApi.getSpecification(this.id);
      this.title = data.title;
      this.createdAt = data.createdAt;
      this.author = data.author?.title || "Не вказано";
      this.issueTrackerRef = data.issueTrackerRef;
      this.isShowEstimate =
        !this.isNew &&
        (!!data.estimateAvg || !!data.estimateMin || !!data.estimateMax);
      this.testIndex = data.testIndex;
      this.setItems(data);
      this.setTotalEstimate(data);
      this.loading = false;
    },
    setItems(data) {
      let currentItems = data.items.map((c) => {
        const item = { ...c };
        item.estimateNormDev = item.estimateAvgDev;
        item.estimateNormAnalyst = item.estimateAvgAnalyst;
        item.estimateNorm = item.estimateAvgDev + item.estimateAvgAnalyst;
        item.estimateMin = item.estimateMinDev + item.estimateMinAnalyst;
        item.estimateMax = item.estimateMaxDev + item.estimateMaxAnalyst;
        item.estimateAvg = item.estimateMaxDev + item.estimateMaxAnalyst;
        item.testIndex = this.testIndex;
        return item;
      });

      const indexTestSection = currentItems.findIndex(
        (s) => s.isTestSection === true
      );
      const testSection = currentItems[indexTestSection];
      const testSectionTitle = testSection.section;
      currentItems.splice(indexTestSection, 1);
      // testSection
      const testSectionTasks = currentItems.filter(
        (t) => t.section === testSectionTitle
      );
      currentItems = currentItems.filter((t) => t.section !== testSectionTitle);
      testSectionTasks.unshift(testSection);
      // testSectionTasks
      const groupedItems = _.groupBy(currentItems, (i) => i.section);
      this.sections = Object.keys(groupedItems);
      this.sections.push(testSectionTitle);

      this.items = [];
      Object.keys(groupedItems).forEach((i) => {
        this.items.push(groupedItems[i]);
      });
      this.items = this.items.sort((a, b) => {
        if (a[0].sectionPosition < b[0].sectionPosition) {
          return -1;
        }
        if (a[0].sectionPosition > b[0].sectionPosition) {
          return 1;
        }
        return 0;
      });
      this.items.push(testSectionTasks);
    },
    setTotalEstimate(data) {
      if (!data) {
        return;
      }
      this.totalTimeSpentSeconds = {
        name: "Факт",
        text: +this.$options.filters.secondsToHours(data.totalTimeSpentSeconds),
      };
      this.factWithGrades = {
        name: "Факт з грейдами",
        text: data.factWithGrades,
        color:
          data.factWithGrades > data.estimateAvg
            ? "red"
            : data.factWithGrades > data.estimateMin &&
              data.factWithGrades <= data.estimateAvg
            ? "yellow darken-2"
            : data.factWithGrades <= data.estimateMin
            ? "green"
            : "grey lighten-2",
      };
      this.devProgress = {
        name: "Прогрес",
        text: `${data.devProgress}%`,
        color:
          data.devProgress === 0
            ? "grey"
            : data.devProgress > 100
            ? "red"
            : "grey lighten-2",
      };
      this.totalEstimate = [
        {
          title: "Загальна оцінка:",
          estimateAvg: data.estimateAvg,
          estimateMin: data.estimateMin,
          estimateNorm: data.estimateAvg,
          estimateMax: data.estimateMax,
        },
      ];
    },
    getColorTotalEstimate(item, estimateName) {
      switch (true) {
        case estimateName === "estimateMin" &&
          this.factWithGrades.text <= item.estimateMin:
          return "green";
        case estimateName === "estimateNorm" &&
          this.factWithGrades.text > item.estimateMin &&
          this.factWithGrades.text <= item.estimateAvg:
          return "#FBC02D";
        case estimateName === "estimateMax" &&
          this.factWithGrades.text > item.estimateAvg:
          return "red";
        default:
          return "default";
      }
    },
    openIssue(jiraIssueKey) {
      window.open(
        `https://atominc.atlassian.net/browse/${jiraIssueKey}`,
        "_blank"
      );
    },
  },
};
</script>
<style>
.fixed-total {
  position: sticky;
  background: white;
  z-index: 3;
}
</style>
